module.exports = __webpack_public_path__ + "static/media/rafiki_rv_contact.d5763fdc.svg";